import { createLogger } from '@heidi/runtime/logger';

export const noteGenerationLogger = createLogger({
  owner: 'scribe',
  domain: 'sessions',
});
